export default {
  init() {
    $('.front-link-boxes-section .btn').on('click', function (e) {
      if( !$(this).attr('href') ) {
        e.preventDefault();
        var parentID = $(this).attr('data-menu-parent');

        if( $(this).hasClass('.is--active') ) {
          $(this).removeClass('.is--active');
          $('.child-menu-container[data-menu-parent="' + parentID + '"]').removeClass('is--toggled');
        } else {
          $('.front-link-boxes-section .btn.is--active').removeClass('is--active');
          $('.child-menu-container.is--toggled').removeClass('is--toggled');
          $(this).addClass('is--active');
          $('.child-menu-container[data-menu-parent="' + parentID + '"]').addClass('is--toggled');
        }
      }
    });
  }
}
